<template>
    <div 
      class="overlay" 
      v-show="show_data" 
      :class="[
        {absolute: absolute},
        {transparent: transparent},
      ]
    ">
        <div class="spinner">
            <div class="rect1"></div>
            <div class="rect2"></div>
            <div class="rect3"></div>
            <div class="rect4"></div>
            <div class="rect5"></div>
        </div>
        <span>{{ message }}</span>
    </div>
</template>

<script>
    export default {
        name: "OverLay",
        props: {
            message: {
              type: String,
              default: "Please wait"
            },
            show: Boolean,
            absolute: {
              type: Boolean,
              default: false
            },
            transparent: {
              type: Boolean,
              default: false
            },
        },
        data: function () {
          return {
            show_data: false
          };
        },
        watch: { 
            show: function(newVal) {
                this.show_data = newVal === 'true' || newVal == 1;
            },
        },
        mounted() {
          const { show } = this;
          this.show_data = show === 'true' || show == 1;
        }
    }
</script>

<style lang="scss">
  @import "@/assets/global.scss";

  .overlay {
      height: 100%;
      width: 100%;
      background: $pp-blue;
      z-index: 99999;
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      opacity: 0.9;

      span {
        color: $white;
        font-weight: 600;
        font-size: 20px;
      }

      &.transparent {
        background: $white;

        span, .spinner > div {
          color: $pp-grey80;
        }

        .spinner {
          margin-bottom: 0;
          margin-top: 0;

          & > div {
            background-color: $pp-grey80;
          }
        }
      }
  }

  .spinner {
    margin: 100px auto;
    width: 50px;
    height: 40px;
    text-align: center;
    font-size: 10px;
  }
</style>